export const formatSensorSerial = (serialNo: number, type: string): string => {
  if (type === '2') { // Hanwell IceSpy
    return serialNo.toString().padStart(8, '0');
  }
  return serialNo.toString();
};

export function isNewerVersion(latestVersion: string, currentVersion: string): boolean {
  if (!currentVersion || !latestVersion) {
    return false;
  }
  
  const partsA = latestVersion.trim().split('.').map(Number);
  const partsB = currentVersion.trim().split('.').map(Number);
  const len = Math.max(partsA.length, partsB.length);

  for (let i = 0; i < len; i++) {
    const a = partsA[i] || 0;
    const b = partsB[i] || 0;
    if (a > b) return true;
    if (a < b) return false;
  }
  
  return false;
}